/**
 * O DETECTOR DE VERSÃO NOVA (18/08).
 *
 * A SPA carrega uma vez e vive na memória — quem deixa a aba aberta (ou usa o
 * app instalado) continua no código de ontem mesmo depois do deploy, e "não
 * funciona" vira conversa de suporte. Três vezes foi o Lucas testando a
 * versão anterior sem saber.
 *
 * A checagem é barata e certeira: o index.html é no-cache e aponta o pacote
 * com hash no nome. Se o hash servido difere do que está rodando, há versão
 * nova — aparece a faixa "Atualizar agora". Checa ao voltar para a aba (o
 * momento em que a pessoa retoma o uso) e a cada 15 minutos.
 */

const CADA_MS = 15 * 60_000;

function pacoteRodando(): string | null {
  for (const s of Array.from(document.scripts)) {
    const m = /\/assets\/(index-[^/]+\.js)/.exec(s.src);
    if (m) return m[1] ?? null;
  }
  return null;
}

async function pacoteServido(): Promise<string | null> {
  try {
    const r = await fetch(`/?v=${Date.now()}`, { cache: 'no-store' });
    const html = await r.text();
    const m = /\/assets\/(index-[^"']+\.js)/.exec(html);
    return m?.[1] ?? null;
  } catch {
    return null; // sem rede agora — a próxima checagem resolve
  }
}

function mostrarFaixa(): void {
  if (document.querySelector('.versao-nova')) return;
  const faixa = document.createElement('div');
  faixa.className = 'versao-nova';
  faixa.innerHTML = `
    <span>🔄 Há uma <b>versão nova</b> do sistema.</span>
    <button class="btn" type="button" id="vn-atualizar">Atualizar agora</button>`;
  document.body.appendChild(faixa);
  faixa.querySelector('#vn-atualizar')!.addEventListener('click', () => location.reload());
}

export function instalarDetectorDeVersao(): void {
  const rodando = pacoteRodando();
  if (!rodando) return;

  let checando = false;
  const checar = async () => {
    if (checando || document.hidden) return;
    checando = true;
    try {
      const servido = await pacoteServido();
      if (servido && servido !== rodando) mostrarFaixa();
    } finally {
      checando = false;
    }
  };

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) void checar();
  });
  setInterval(() => void checar(), CADA_MS);
  // Uma primeira olhada logo após abrir: pega o caso da aba restaurada.
  setTimeout(() => void checar(), 20_000);
}
